import React from "react";
import { Helmet } from 'react-helmet-async';
import '../../../assets/styles/Wireframing.css'
import wireframeHero from "../../../assets/images/Wireframing.png";
import wireframeTools from "../../../assets/images/Wireframing.png";

const WireframingPage = () => {
  return (
    <>
      <Helmet>
        {/* <!-- Primary Meta Tags for SEO --> */}
        <title> Wireframing – BuddyTech Solutions </title>
        <meta name="description" content="Content-first wireframes to outline clear user flows and product structures." />
        <meta name="keywords" content="wireframing, UX flows" />

        {/* <!-- Open Graph / Facebook Meta Tags --> */}
        <meta property="og:title" content="Wireframing – BuddyTech Solutions" />
        <meta property="og:description" content="Content-first wireframes to outline clear user flows and product structures." />
        <meta property="og:keywords" content="wireframing, UX flows" />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/services/uiux/wireframing" />
        <meta property="og:type" content="website" />

        {/* <!-- Optional: Facebook App ID --> */}
        {/* <!-- <meta property="fb:app_id" content="your_facebook_app_id" /> --> */}

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Wireframing – BuddyTech Solutions" />
        <meta name="twitter:description" content="Content-first wireframes to outline clear user flows and product structures." />
        <meta name="twitter:keywords" content="wireframing, UX flows" />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
      </Helmet>
      <div className="wireframe-container">
        <header className="wireframe-hero">
          <div className="wireframe-hero-content">
            <h1>Wireframing & Prototyping</h1>
            <p>
              We turn your ideas into structured, navigable wireframes that serve as blueprints for seamless, user-centered digital experiences.
            </p>
          </div>
          <img src={wireframeHero} alt="Wireframe Hero" className="wireframe-hero-img" />
        </header>

        <section className="wireframe-section">
          <div className="wireframe-text">
            <h2>What We Offer</h2>
            <p>
              Our wireframes map out layout, content hierarchy, and user journeys before diving into design and development, ensuring aligned expectations and a solid foundation.
            </p>
            <ul>
              <li>Low & High Fidelity Wireframes</li>
              <li>User Journey Mapping</li>
              <li>Interactive Prototypes</li>
              <li>Responsive Screen Flows</li>
              <li>Clickable Navigation & Transitions</li>
            </ul>
          </div>
          <img src={wireframeTools} alt="Wireframe Samples" className="wireframe-img" />
        </section>

        <section className="wireframe-tools">
          <h2>Tools We Use</h2>
          <div className="tools-grid">
            <span>Figma</span>
            <span>Adobe XD</span>
            <span>Sketch</span>
            <span>Axure RP</span>
            <span>Balsamiq</span>
            <span>InVision</span>
            <span>Whimsical</span>
            <span>Marvel App</span>
          </div>
        </section>
        <h2 className="permanent-marker-regular">specialist - 1</h2>
        <section className="contact-options">
          <div className="contact-card email">
            <h2>📧 Email</h2>
            <p>Send us an email for inquiries, support or collaboration opportunities.</p>
            <a href="mailto:sureshperiyasamy98@gmail.com" target="_blank" rel="noopener noreferrer">
              Send Email
            </a>
          </div>

          <div className="contact-card whatsapp">
            <h2>💬 WhatsApp</h2>
            <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
            <a href="https://wa.me/919361367843" target="_blank" rel="noopener noreferrer">
              Chat on WhatsApp
            </a>
          </div>

          <div className="contact-card phone">
            <h2>📞 Call Us</h2>
            <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
            <a href="tel:+919361367843">Call Us</a>
          </div>
        </section>
        <h2 className="permanent-marker-regular">specialist - 2</h2>
        <section className="contact-options">
          <div className="contact-card email">
            <h2>📧 Email</h2>
            <p>Send us an email for inquiries, support or collaboration opportunities.</p>
            <a href="mailto:jprakash0502@gmail.com" target="_blank" rel="noopener noreferrer">
              Send Email
            </a>
          </div>

          <div className="contact-card whatsapp">
            <h2>💬 WhatsApp</h2>
            <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
            <a href="https://wa.me/919994694028" target="_blank" rel="noopener noreferrer">
              Chat on WhatsApp
            </a>
          </div>

          <div className="contact-card phone">
            <h2>📞 Call Us</h2>
            <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
            <a href="tel:+919994694028">Call Us</a>
          </div>
        </section>
        <h2 className="permanent-marker-regular">specialist - 3</h2>
        <section className="contact-options">
          <div className="contact-card email">
            <h2>📧 Email</h2>
            <p>Send us an email for inquiries, support or collaboration opportunities.</p>
            <a href="mailto:swethadee1407@gmail.com" target="_blank" rel="noopener noreferrer">
              Send Email
            </a>
          </div>

          <div className="contact-card whatsapp">
            <h2>💬 WhatsApp</h2>
            <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
            <a href="https://wa.me/916379359918" target="_blank" rel="noopener noreferrer">
              Chat on WhatsApp
            </a>
          </div>

          <div className="contact-card phone">
            <h2>📞 Call Us</h2>
            <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
            <a href="tel:+916379359918">Call Us</a>
          </div>
        </section>
      </div>
    </>
  );
};

export default WireframingPage;
